import { Component } from '@angular/core';
import { NewAddressFormBaseComponent } from '../../../standalone-components/new-address-form/new-addres-form-base';

@Component({
    selector: 'app-address-form',
    templateUrl: './address-form.component.html',
    styleUrls: ['./address-form.component.scss'],
    standalone: false
})
export class AddressFormComponent extends NewAddressFormBaseComponent { }
